export default "__VITE_ASSET__96zV818f__"